import { Options } from "./options";

export class ShareViaLink {
  options:Options;
  }

 
